import axiosInstance from './axiosInstance';

export interface ArticleRow {
  id: string;
  gameId: string;
  title: string;
  content: string;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export class ArticleApi {
  static async list(skip = 0, limit = 20, query?: { gameId?: string; title?: string }): Promise<{ list: ArticleRow[]; total: number }> {
    const response = await axiosInstance.get('/cms/v1/article', {
      params: {
        skip,
        limit,
        gameId: query?.gameId || undefined,
        title: query?.title || undefined,
      },
    });
    return response.data.data;
  }

  static async get(id: string): Promise<ArticleRow> {
    const response = await axiosInstance.get(`/cms/v1/article/${id}`);
    return response.data.data.article;
  }

  static async getByGameId(gameId: string): Promise<ArticleRow | null> {
    const response = await axiosInstance.get(`/cms/v1/article/game/${gameId}`);
    return response.data.data.article;
  }

  static async create(payload: { gameId: string; title: string; content: string }): Promise<ArticleRow> {
    const response = await axiosInstance.post('/cms/v1/article', payload);
    return response.data.data.article;
  }

  static async update(id: string, payload: Partial<Pick<ArticleRow, 'gameId' | 'title' | 'content'>>): Promise<ArticleRow> {
    const response = await axiosInstance.put(`/cms/v1/article/${id}`, payload);
    return response.data.data.article;
  }

  static async remove(id: string): Promise<void> {
    await axiosInstance.delete(`/cms/v1/article/${id}`);
  }
}
